import { render, staticRenderFns } from "./SanitizedHtml.vue?vue&type=template&id=cd1ac45e"
import script from "./SanitizedHtml.vue?vue&type=script&lang=js"
export * from "./SanitizedHtml.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports